import * as contentfulData from './contentful.json';
import type {
  Entry,
  Asset,
  Area,
  Point,
  Settings,
} from './types';

const areas: Area[] = [];
const points: Point[] = [];
let settings: Settings;
(contentfulData.entries as unknown[] as Entry[]).forEach((entry: Entry) => {
  if (entry.sys.contentType.sys.id === 'area') {
    areas.push(entry as Area);
  } else if (entry.sys.contentType.sys.id === 'point') {
    points.push(entry as Point);
  } else if (entry.sys.contentType.sys.id === 'settings') {
    settings = entry as Settings;
  }
});

const assets: Asset[] = contentfulData.assets as Asset[];
areas.sort((areaA, areaB) => {
  return areaA.fields.radius['en-US'] - areaB.fields.radius['en-US'];
})

export {
  areas,
  points,
  settings,
  assets,
};
export * from './types';
